import {useIsFeatureActive} from '@aboutyou/feature-flags';
import {
  HubPageCardsSlider,
  HubPageMeta,
  HubPageStream,
  ProductMiniAdpWithBasketFlyout,
  ProductsGridWithTeaser,
  SizeSelectionOpenedStateKey,
  SportswearStreamTileList,
  useMiniAdpDialogOpenedState,
} from '@aboutyou/logic-components';
import {Redirect} from '@aboutyou/router';
import React from 'react';

export const SportswearPage: React.FC = () => {
  const {open: openProductMiniADPDialog} = useMiniAdpDialogOpenedState();
  const isSportswearPageActive = useIsFeatureActive('sportswear_page').isActive;

  if (!isSportswearPageActive) {
    return <Redirect to={'/'} />;
  }

  return (
    <>
      <HubPageMeta />
      <HubPageStream
        SliderComponent={HubPageCardsSlider}
        ProductsComponent={ProductsGridWithTeaser}
        onAddToBasketCtaClick={openProductMiniADPDialog}
        StreamTileList={SportswearStreamTileList}
      />

      <ProductMiniAdpWithBasketFlyout
        showAddToWishlistButton
        sizeSelectionStateManagerKey={
          SizeSelectionOpenedStateKey.BASKET_FLYOUT_SIZE_SELECTION
        }
      />
    </>
  );
};
